var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Stats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 93.5,
    fill: "#277871",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0117 92.3862C46.0117 89.5212 48.3347 87.1982 51.1997 87.1982C54.0647 87.1982 56.3877 89.5212 56.3877 92.3862C56.3877 95.2512 54.0647 97.5742 51.1997 97.5742C48.3347 97.5742 46.0117 95.2512 46.0117 92.3862Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9512 92.3862C98.9512 89.5212 101.274 87.1982 104.139 87.1982C107.004 87.1982 109.327 89.5212 109.327 92.3862C109.327 95.2512 107.004 97.5742 104.139 97.5742C101.274 97.5742 98.9512 95.2512 98.9512 92.3862Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.246 115.885C105.061 129.345 92.5058 139.118 77.6688 139.118C62.8318 139.118 50.2778 129.345 46.0918 115.885H109.246Z",
    stroke: "white",
    strokeWidth: 4.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Stats);
export default __webpack_public_path__ + "static/media/100-stats.be1b2451450a30932dd8b82d4d8e9e20.svg";
export { ForwardRef as ReactComponent };